<svg [attr.height]="size" [attr.width]="size" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.37109 12H16.3711" [attr.stroke]="color" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round"/>
  <path d="M12.3711 16V8" [attr.stroke]="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path
    d="M9.37109 22H15.3711C20.3711 22 22.3711 20 22.3711 15V9C22.3711 4 20.3711 2 15.3711 2H9.37109C4.37109 2 2.37109 4 2.37109 9V15C2.37109 20 4.37109 22 9.37109 22Z"
    [attr.stroke]="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
